"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var DeactivationScheduleIcon_1 = __importDefault(require("../../Icons/DeactivationScheduleIcon"));
var react_i18next_1 = require("react-i18next");
var BlDateTime_1 = __importDefault(require("../../FormComponents/BlDateTime"));
var react_redux_1 = require("react-redux");
var myAnnouncementsSlice_1 = require("../../../features/myAnnouncements/myAnnouncementsSlice");
var moment_1 = __importDefault(require("moment"));
var globalSlice_1 = require("../../../features/global/globalSlice");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DeactivationModal = function (_a) {
    var postId = _a.postId, handleOpenDeactivationModal = _a.handleOpenDeactivationModal;
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var deactivationLoading = react_redux_1.useSelector(myAnnouncementsSlice_1.toggleActiveLoadingSelector);
    var _b = react_1.useState(), selectedDate = _b[0], setSelectedDate = _b[1];
    var handleSubmitDeactivation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var date;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    date = moment_1.default(selectedDate);
                    setSelectedDate(null);
                    return [4 /*yield*/, dispatch(myAnnouncementsSlice_1.deActivatePost(postId, date.format('YYYY/MM/DD')))];
                case 1:
                    _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('MY_ANNOUNCEMENT.DEACTIVATE_STATUS'),
                        appearance: 'success',
                    }));
                    handleOpenDeactivationModal('');
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(semantic_ui_react_1.Modal, { size: "small", open: true },
        react_1.default.createElement(semantic_ui_react_1.Modal.Header, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement(DeactivationScheduleIcon_1.default, null),
                react_1.default.createElement("p", null, t('MY_ANNOUNCEMENTS.DEACTIVATE_POST_MODAL.TITLE')))),
        react_1.default.createElement(semantic_ui_react_1.Modal.Content, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement(BlDateTime_1.default, { onChange: function (data) {
                        setSelectedDate(data);
                    }, selected: selectedDate, minDate: moment_1.default().add(1, 'days').toDate() }),
                react_1.default.createElement("p", null, t('MY_ANNOUNCEMENTS.DEACTIVATE_POST_MODAL.DESCRIPTION')))),
        react_1.default.createElement(semantic_ui_react_1.Modal.Actions, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.actions },
                react_1.default.createElement("button", { onClick: function () { return handleOpenDeactivationModal(''); }, className: "btn btn-outline-primary", disabled: deactivationLoading }, t('MY_ANNOUNCEMENTS.DEACTIVATE_POST_MODAL.ACTIONS.CANCEL')),
                react_1.default.createElement("button", { onClick: function () { return handleSubmitDeactivation(); }, className: "btn btn-primary", disabled: !selectedDate }, t('MY_ANNOUNCEMENTS.DEACTIVATE_POST_MODAL.ACTIONS.CONFIRM'))))));
};
exports.default = react_1.memo(DeactivationModal);
